export const PAYMENT_LINK_DEFAULTS = {
  enabled: false,
  description: ''
};

export const DESCRIPTION_MAX = 500;

export const getPaymentLinkSettings = (displaySettings) => ({
  ...PAYMENT_LINK_DEFAULTS,
  ...(displaySettings?.standalone_payment || {})
});
